import { createFileRoute } from '@tanstack/react-router';
import { GeneralSettings } from '@/features/projects/settings/general-settings';

export const Route = createFileRoute('/_app/p/$projectKey/settings/general')({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectKey } = Route.useParams();
  return <GeneralSettings projectKey={projectKey} />;
}
